/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetailerEmailUserInput
 */
export interface RetailerEmailUserInput {
    /**
     * 
     * @type {string}
     * @memberof RetailerEmailUserInput
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RetailerEmailUserInput
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RetailerEmailUserInput
     */
    value?: string | null;
}

export function RetailerEmailUserInputFromJSON(json: any): RetailerEmailUserInput {
    return RetailerEmailUserInputFromJSONTyped(json, false);
}

export function RetailerEmailUserInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerEmailUserInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function RetailerEmailUserInputToJSON(value?: RetailerEmailUserInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'value': value.value,
    };
}


